import React from 'react';
import {
  Button, Header, List, Loader, Segment,
} from 'semantic-ui-react';
import moment from 'moment';

const ownerName = (owner) => {
  if (!owner) return '';
  return [owner.firstName, owner.lastName].filter(Boolean).join(' ') || owner.email;
};

const SessionItems = ({
  sessions, activeSessionId, onSelectSession, showOwner,
}) => (
  <List selection verticalAlign="middle">
    {sessions.map((session) => (
      <List.Item
        key={session.id}
        active={session.id === activeSessionId}
        onClick={() => onSelectSession(session.id)}
      >
        <List.Content>
          <List.Header>{session.title || 'New chat'}</List.Header>
          {showOwner && session.owner && (
            <List.Description>{`Shared by ${ownerName(session.owner)}`}</List.Description>
          )}
          {session.lastMessageAt && (
            <List.Description>{moment(session.lastMessageAt).fromNow()}</List.Description>
          )}
        </List.Content>
      </List.Item>
    ))}
  </List>
);

// Project sessions are shared by the whole team, so they're one flat list.
// Team/global sessions are private, so they're split into the user's own
// sessions and the ones teammates shared with them (read-only).
const SessionList = ({
  sessions, loading, activeSessionId, onSelectSession, onNewChat, groupByOwnership,
}) => {
  const ownSessions = groupByOwnership ? sessions.filter((s) => s.isOwner) : sessions;
  const sharedSessions = groupByOwnership ? sessions.filter((s) => !s.isOwner) : [];

  return (
    <div>
      <Button fluid primary icon="plus" content="New chat" onClick={onNewChat} style={{ marginBottom: '1em' }} />
      {loading && sessions.length === 0 && <Loader active inline="centered" />}
      {!loading && sessions.length === 0 && (
        <Segment basic textAlign="center">
          <p>No chat sessions yet.</p>
        </Segment>
      )}
      {groupByOwnership && ownSessions.length > 0 && sharedSessions.length > 0 && (
        <Header as="h5">My chats</Header>
      )}
      <SessionItems
        sessions={ownSessions}
        activeSessionId={activeSessionId}
        onSelectSession={onSelectSession}
      />
      {sharedSessions.length > 0 && (
        <>
          <Header as="h5">Shared with me</Header>
          <SessionItems
            sessions={sharedSessions}
            activeSessionId={activeSessionId}
            onSelectSession={onSelectSession}
            showOwner
          />
        </>
      )}
    </div>
  );
};

export default SessionList;
